import React, { useEffect, useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom';
import Popupform from '../Popupform/Popupform';
import Boucherpopup from '../Popupform/Boucherpopup';
import axios from 'axios';
import config from '../../config/config';
import { FiMapPin, FiAward, FiArrowRight, FiDownload } from 'react-icons/fi';

const InnerColleges = () => {
    const location = useLocation();
    const { state } = location.state || {};
    const [tableData, setTableData] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showBoucherPopup, setShowBoucherPopup] = useState(false);

    useEffect(() => {
        const fetchCollegeData = async () => {
            try {
                const querydata = { state };
                const response = await axios.get(`${config.API_BASE_URL}/api/admin/get_collegespageByCourseAndcity`, {
                    params: querydata
                });
                setTableData(response.data.collegesByCourseName || []);
            } catch (error) {
                console.error("Error fetching college data:", error);
            }
        };
        fetchCollegeData();
    }, [state]);

    const handleOpenPopup = (e) => {
        if (e) e.preventDefault();
        setShowPopup(true);
        document.body.style.overflow = "hidden";
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        document.body.style.overflow = "auto";
    };

    const handleOpenBoucherPopup = (e) => {
        if (e) e.preventDefault();
        setShowBoucherPopup(true);
    };

    const handleCloseBoucherPopup = () => {
        setShowBoucherPopup(false);
    };

    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div className="bg-brand-orange pt-48 pb-20 px-4 text-center relative overflow-hidden">
                <div className="absolute inset-0 bg-black/10"></div>
                <div className="relative z-10 max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                        Colleges in {state || "Your Region"}
                    </h2>
                    <p className="text-white text-lg opacity-90 leading-relaxed max-w-2xl mx-auto">
                        Looking for the perfect city to pursue your dreams? Explore the top study destinations in India,
                        known for their prestigious universities and excellent career opportunities.
                    </p>
                </div>
            </div>

            {/* Content Section */}
            <div className="container mx-auto px-4 py-16">
                <div className="bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden">

                    {/* Desktop Header */}
                    <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b border-gray-100 text-xs font-bold text-gray-400 uppercase tracking-wider bg-gray-50">
                        <div className="col-span-1 text-center">Rank</div>
                        <div className="col-span-5">University Info</div>
                        <div className="col-span-2">Fees</div>
                        <div className="col-span-2">Placement</div>
                        <div className="col-span-2">Eligibility</div>
                    </div>

                    {tableData.length > 0 ? (
                        tableData.map((item, index) => (
                            <React.Fragment key={index}>
                                {/* Mobile Card View */}
                                <div className="md:hidden bg-white border-b border-gray-100 last:border-0 p-5 relative">
                                    <div className="flex items-start gap-4 mb-4">
                                        <div className="absolute top-0 left-0 bg-yellow-400 text-white text-[10px] font-bold px-3 py-1 rounded-br-lg shadow-sm z-10">
                                            #{item.rank}
                                        </div>

                                        <div className="mt-6 flex-1">
                                            <NavLink
                                                to={`/college/${item._id}`}
                                                className="font-bold text-gray-900 leading-tight text-lg block mb-1 hover:text-brand-orange"
                                            >
                                                {item.collegeName}
                                            </NavLink>
                                            <div className="flex items-center text-xs text-gray-500 mb-2">
                                                <FiMapPin className="mr-1" /> {item.city}
                                            </div>
                                            <p className="text-xs text-gray-400 mb-3 line-clamp-2">{item.subheading}</p>
                                        </div>
                                    </div>

                                    {/* Details Grid */}
                                    <div className="grid grid-cols-2 gap-4 border-t border-gray-50 pt-3 mb-4">
                                        <div>
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Fees</p>
                                            <p className="text-sm font-bold text-gray-800">&#8377; {item.fee}</p>
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Placement (Avg)</p>
                                            <p className="text-sm font-bold text-green-600">&#8377; {item.placementavg}</p>
                                        </div>
                                        <div className="col-span-2 border-t border-gray-50 pt-2 mt-2">
                                            <p className="text-[10px] text-gray-400 uppercase font-bold">Eligibility</p>
                                            <p className="text-xs text-gray-600">{item.eligibility}</p>
                                        </div>
                                    </div>

                                    {/* Actions */}
                                    <div className="flex flex-col sm:flex-row gap-2">
                                        <button
                                            onClick={handleOpenPopup}
                                            className="flex-1 bg-brand-orange text-white text-sm font-bold py-3 rounded-lg hover:bg-orange-600 transition flex items-center justify-center"
                                        >
                                            Apply Now <FiArrowRight className="ml-2" />
                                        </button>
                                        <button
                                            onClick={handleOpenBoucherPopup}
                                            className="flex-1 bg-gray-50 text-gray-700 border border-gray-200 text-sm font-bold py-3 rounded-lg hover:bg-gray-100 transition flex items-center justify-center"
                                        >
                                            <FiDownload className="mr-2" /> Brochure
                                        </button>
                                    </div>
                                </div>

                                {/* Desktop Row View */}
                                <div className="hidden md:grid grid-cols-12 gap-4 p-5 border-b last:border-0 border-gray-50 hover:bg-orange-50/30 transition items-center group">
                                    <div className="col-span-1 text-center font-bold text-gray-400 group-hover:text-brand-orange">
                                        #{item.rank}
                                    </div>
                                    <div className="col-span-5">
                                        <NavLink to={`/college/${item._id}`} className="text-lg font-bold text-gray-800 hover:text-brand-orange transition block mb-1">
                                            {item.collegeName}
                                        </NavLink>
                                        <div className="flex items-center text-xs text-gray-500 mb-1">
                                            <FiMapPin className="mr-1" /> {item.city}
                                        </div>
                                        <p className="text-xs text-gray-400 mb-2">{item.subheading}</p>
                                        <div className="flex gap-4">
                                            <button onClick={handleOpenPopup} className="text-xs font-bold text-brand-orange hover:underline flex items-center">
                                                Apply Now <FiArrowRight className="ml-1" />
                                            </button>
                                            <button onClick={handleOpenBoucherPopup} className="text-xs font-medium text-gray-500 hover:text-gray-800 flex items-center">
                                                <FiDownload className="mr-1" /> Brochure
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-span-2 font-bold text-gray-800">
                                        &#8377; {item.fee}
                                    </div>
                                    <div className="col-span-2">
                                        <div className="font-bold text-green-600">&#8377; {item.placementavg}</div>
                                        <div className="text-[10px] text-gray-400 uppercase font-bold">Avg</div>
                                    </div>
                                    <div className="col-span-2 text-sm text-gray-600">
                                        {item.eligibility}
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                    ) : (
                        <div className="p-12 text-center text-gray-500">
                            No colleges found for this selection.
                        </div>
                    )}
                </div>
            </div>

            {/* Popup Logic */}
            {showPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleClosePopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Popupform />
                    </div>
                </div>
            )}

            {showBoucherPopup && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl relative w-full max-w-md overflow-hidden max-h-[90vh] overflow-y-auto">
                        <button onClick={handleCloseBoucherPopup} className="absolute top-4 right-4 text-gray-400 hover:text-gray-800 transition z-10 bg-white rounded-full p-1 border">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <Boucherpopup />
                    </div>
                </div>
            )}

        </div>
    )
}

export default InnerColleges;
